export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.9fd102a758589dbdcf1fbe9f8ae53ff5.css";